<template>
  <div class="function-pie-chart">
    <!-- 加载状态 -->
    <div v-if="loading" class="chart-loading">
      <i class="el-icon-loading"></i>
      <span>数据加载中...</span>
    </div>

    <!-- 空数据状态 -->
    <div v-else-if="!hasData" class="chart-empty">
      <i class="el-icon-pie-chart"></i>
      <span>暂无数据</span>
    </div>

    <!-- 图表容器 -->
    <div v-else ref="chart" class="chart-container"></div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'function-pie-chart',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      chart: null,
      resizeHandler: null
    }
  },

  computed: {
    hasData() {
      return this.data && this.data.length > 0
    },

    chartData() {
      if (!this.hasData) return []
      return this.data.filter(item => item.value > 0)
    }
  },

  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (this.hasData && !this.chart) {
            this.initChart()
          } else if (this.chart) {
            this.renderChart()
          }
        })
      },
      deep: true
    },

    loading(newVal) {
      if (!newVal && this.hasData) {
        this.$nextTick(() => {
          if (!this.chart) {
            this.initChart()
          } else {
            this.renderChart()
          }
        })
      }
    }
  },

  mounted() {
    this.initChart()
    this.bindEvents()
  },

  beforeDestroy() {
    this.unbindEvents()
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    initChart() {
      if (!this.$refs.chart) return
      this.chart = echarts.init(this.$refs.chart)
      this.renderChart()
    },

    renderChart() {
      // 先检查数据，无数据时销毁图表实例
      if (!this.hasData) {
        if (this.chart) {
          this.chart.dispose()
          this.chart = null
        }
        return
      }

      if (!this.chart) return

      // 固定颜色映射
      const colorMap = {
        '人脸对比': '#4facfe',
        '静态活体': '#fad961',
        '动态活体': '#fa7c91'
      }

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} 次 ({d}%)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#e8eaec',
          borderWidth: 1,
          textStyle: {
            color: '#1f2d3d'
          }
        },
        legend: {
          orient: 'horizontal',
          bottom: '5%',
          left: 'center',
          textStyle: {
            color: '#1f2d3d',
            fontSize: 13
          },
          itemWidth: 20,
          itemHeight: 14
        },
        series: [
          {
            name: '功能类型分布',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}\n{d}%',
              fontSize: 12,
              color: '#1f2d3d'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.3)'
              }
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 10
            },
            data: this.chartData.map(item => ({
              name: item.name,
              value: item.value,
              itemStyle: {
                color: colorMap[item.name] || '#4facfe'
              }
            }))
          }
        ]
      }

      this.chart.setOption(option, true)
    },

    bindEvents() {
      this.resizeHandler = () => {
        if (this.chart) {
          this.chart.resize()
        }
      }
      window.addEventListener('resize', this.resizeHandler)
    },

    unbindEvents() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
        this.resizeHandler = null
      }
    }
  }
}
</script>

<style scoped>
.function-pie-chart {
  height: 100%;
  position: relative;
  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);
  border-radius: 12px;
  padding: 8px;
}

.chart-container {
  width: 100%;
  height: 320px;
}

.chart-loading,
.chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 320px;
  color: #909399;
  font-size: 14px;
}

.chart-loading i,
.chart-empty i {
  font-size: 48px;
  margin-bottom: 12px;
}
</style>




// WEBPACK FOOTER //
// src/custom/components/stats/face-stats/components/function-pie-chart.vue